import {ProductionCostBusProvidedValuesEntry} from '@/Pages/ProductionCost/store/types';
import {
  BusInputValidationErrorExtensions,
  ScheduleInputValidationErrorExtensions
} from '../../types';

export const getScheduleInputValidationErrorMessage = (
  error: ScheduleInputValidationErrorExtensions
) => {
  switch (error.errorCode) {
    case 'schedules.intersection.holiday':
      return `${error.invalidDays.length} days covered by multiple holiday schedules`;
    case 'schedules.intersection.regular':
      return `${error.invalidDays.length} days covered by multiple regular schedules`;
    default: {
      const fallbackMessage = `Unknown error code for schedule input validation error: ${error.errorCode}`;
      console.error(fallbackMessage);
      return fallbackMessage;
    }
  }
};

export const geBusInputValidationErrorMessage = (
  error: BusInputValidationErrorExtensions,
  vehicleSettings: ProductionCostBusProvidedValuesEntry
) => {
  switch (error.errorCode) {
    case 'providedValuesEntries.busesWithMultipleLinesAndBusUtilizationFactors':
      return `Multiple lines and bus utilization factors chosen for vehicle ${vehicleSettings.vehicleName}`;
    case 'providedValuesEntries.busesWithMultipleLinesAndFlixStandardCostOverwrite':
      return `Multiple lines and flix standard cost overwrite chosen for vehicle ${vehicleSettings.vehicleName}`;
    default: {
      const fallbackMessage = `Unknown error code for bus input validation error: ${error.errorCode}`;
      console.error(fallbackMessage);
      return fallbackMessage;
    }
  }
};
